import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react'
import MainNavigator from './navigation';
import "./assets/sass/main.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PusherProvider } from "./PusherContext";
import Pusher from 'pusher-js';

// ✅ Imports Capacitor
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

const pusher = new Pusher('8dfc788b8c1d27a7b8f5', {
  cluster: 'eu',
  forceTLS: true
});

// ✅ Composant wrapper pour gérer la StatusBar
function AppWithStatusBar() {
  useEffect(() => {
    // Configure SEULEMENT sur les plateformes natives (iOS/Android)
    if (Capacitor.isNativePlatform()) {
      
      // Configuration iOS
      if (Capacitor.getPlatform() === 'ios') {
        // Style.Light = contenu blanc sur fond sombre
        // Style.Dark = contenu noir sur fond clair
        StatusBar.setStyle({ style: Style.Light }); 
        StatusBar.setBackgroundColor({ color: '#35cdd7' }); // Couleur de ton header
        StatusBar.setOverlaysWebView({ overlay: false });
      }
      
      // Configuration Android
      if (Capacitor.getPlatform() === 'android') {
        StatusBar.setStyle({ style: Style.Light });
        StatusBar.setBackgroundColor({ color: '#35cdd7' });
      }
      
      // ✅ Force un repaint pour appliquer les safe areas immédiatement
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
        // Force le recalcul des variables CSS env()
        document.documentElement.style.setProperty('--force-repaint', '1');
      }, 100);
    }
  }, []);

  return (
    <PusherProvider pusher={pusher}>
      <MainNavigator />
    </PusherProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AppWithStatusBar />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);